export default __webpack_public_path__ + "static/media/ADOBE.2c3a3d25.png";